var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deals-Items',{attrs:{"coupons":_vm.coupons,"isHome":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }